<template>
  <div class="defaultUpload">
    <h2>Добавить пользователя</h2>
    <ElemInput
      valueName="login"
      @changeValue="changeValue"
      :valueProp="login"
      label="Логин"
    />

    <ElemInput
      valueName="email"
      @changeValue="changeValue"
      :valueProp="email"
      label="email"
    />

    <ElemInput
      valueName="password"
      @changeValue="changeValue"
      :valueProp="password"
      label="Пароль"
    />

    <ElemInput
      valueName="name"
      @changeValue="changeValue"
      :valueProp="name"
      label="Имя"
    />

    <ElemInput
      valueName="surname"
      @changeValue="changeValue"
      :valueProp="surname"
      label="Фамилия"
    />

    <ElemInput
      valueName="patronymic"
      @changeValue="changeValue"
      :valueProp="patronymic"
      label="Отчество"
    />

    <ElemInput
      valueName="birthday"
      @changeValue="changeValue"
      :valueProp="birthday"
      type="date"
      label="Дата рождения"
    />

    <button class="addTitleImage" @click="openPickImage = true" type="button">
      аватар
    </button>

    <img
      v-if="avatar"
      class="avatar"
      :src="baseUrl + 'storage/images/' + avatar"
    />

    <PickGallery
      v-if="openPickImage"
      @close="openPickImage = false"
      @pickImage="pickImage"
    />

    <div class="form-actions">
      <button type="button" v-on:click="createUser">Загрузить</button>
    </div>
  </div>
</template>

<script>
import PickGallery from "@/components/gallery/PickGallery";
import ElemInput from "@/components/elements/elemInput";
import users from "@/composables/views/users.ts";

export default {
  setup() {
    const {
      login,
      updateUser,
      avatar,
      email,
      name,
      surname,
      patronymic,
      birthday,
      baseUrl,
      createUser,
      openPickImage,
      password,
    } = users();
    return {
      login,
      updateUser,
      avatar,
      email,
      name,
      surname,
      patronymic,
      birthday,
      baseUrl,
      createUser,
      openPickImage,
      password,
    };
  },
  data: () => ({}),
  components: {
    PickGallery,
    ElemInput,
  },
  methods: {
    changeValue(valueName, value) {
      this[valueName] = value;
    },
    pickImage(image) {
      this.avatar = image;
      this.openPickImage = false;
    },
  },
  created() {
  },
};
</script>